import React, { useEffect, useState } from 'react';
import styles from './style.module.css';

function DaySelector({ chargerDynamicRateApplicableDays, onSelectedDayChange, rateIndex, customDays}) {
  const [days, setDays] = useState(["S", "M", "T", "W", "T", "F", "S"]);
  const [chargerDynamicRateApplicableDaysState, setChargerDynamicRateApplicableDaysState] = useState(chargerDynamicRateApplicableDays);

  useEffect(()=>{
    console.log("useeff day sele",customDays)
    if(customDays === 'weekends'){
      setChargerDynamicRateApplicableDaysState([1,0,0,0,0,0,1])
    }
    if(customDays === 'weekdays'){
      setChargerDynamicRateApplicableDaysState([0,1,1,1,1,1,0])
    }
    console.log(chargerDynamicRateApplicableDaysState)
  },[chargerDynamicRateApplicableDays])
  const toggleDay = (index) => {
    const updatedDays = [...chargerDynamicRateApplicableDaysState];
    updatedDays[index] = updatedDays[index] === 1 ? 0 : 1;
    
    setChargerDynamicRateApplicableDaysState(updatedDays);
    onSelectedDayChange(updatedDays, rateIndex)
  };

  return (
    <div className={styles["daySelectionDiv"]}>
      {days.map((day, index) => {
        return (
          <div
            key={index}
            onClick={() => toggleDay(index)}
            className={`${styles.dayDiv} ${chargerDynamicRateApplicableDaysState[index] === 1 ? styles.enabledDay : styles.disabledDay}`}
          >
            {day}
          </div>
        );
      })}
    </div>
  );
}

export default DaySelector;
